import { WmsStockInfo } from '../types';

export default function WarehouseStock({ stock, unit = 'pz' }: { stock: WmsStockInfo; unit?: string }) {
  if (!stock.wms_available || !stock.warehouses?.length) return null;

  return (
    <ul aria-label="Disponibilità per magazzino" className="text-xs text-gray-600 space-y-0.5">
      {stock.warehouses.map((warehouse) => (
        <li key={warehouse.warehouse_id}>
          {warehouse.warehouse_name || warehouse.warehouse_id}: {' '}
          <strong>{warehouse.available_quantity.toLocaleString('it-IT')} {unit}</strong>
        </li>
      ))}
    </ul>
  );
}
